import { IntlShape } from 'react-intl'

export type EntranceStepTranslation = ReturnType<typeof getEntraceStepTranslations>

export const getEntraceStepTranslations = (formatMessage: IntlShape['formatMessage']) =>
  ({
    introSection: {
      heading: formatMessage({ id: 'common-digila-site-header' }),
      leadText: formatMessage({ id: 'digila-entrance-lead-text' }),
    },
    serviceInfoSection: {
      header: formatMessage({ id: 'digila-entrance-service-info-header' }),
      texts: [
        formatMessage({ id: 'digila-entrance-service-info-text-1' }),
        formatMessage({ id: 'digila-entrance-service-info-text-2' }),
        formatMessage({ id: 'digila-entrance-service-info-text-3' }),
        formatMessage({ id: 'digila-entrance-service-info-text-4' }),
      ],
      linkHref: formatMessage({ id: 'digila-entrance-service-info-external-link-href' }),
      linkText: formatMessage({ id: 'digila-entrance-service-info-external-link-text' }),
    },
    confirmButtonLabel: formatMessage({ id: 'common-continue' }),
  }) as const
